module.exports = __webpack_public_path__ + "img/el_menu6.07b083dc.png";